import { isIgnoredEventType } from './ignoredEventTypes'
import { challengeEventType } from './challengeEventType'
import { logTransducerError } from './logTransducerError'
import type { CreateReducerFunction, Handler } from './types'

export const createReducer: CreateReducerFunction =
  (namespace, handlers) => (state, event) => {
    const { type, payload = [] } = event ?? {}
    let nextState = (state ?? {}) as NonNullable<typeof state>

    try {
      if (typeof type === 'undefined' || isIgnoredEventType(type)) {
        return nextState
      }

      const handler = challengeEventType(type, handlers) as Handler<
        typeof state
      >
      nextState = handler(state, ...payload) as NonNullable<typeof state>
    } catch (error) {
      logTransducerError(namespace, error, event)
    }

    return nextState
  }
